import React, { useState, useEffect } from 'react';
import { Typography,Container, Grid } from '@mui/material';
import ViewSecret from '../Components/ViewSecret';
import Faq from '../Components/Faq';
import { useParams } from 'react-router-dom'; // Import useParams hook

const View = () => {
    const { secretId } = useParams(); // This will fetch the secretId from the URL path
    const [decryptKey, setDecryptKey] = useState('');

    useEffect(() => {
        // Check if hash exists in the URL
        const hash = window.location.hash; // e.g., #k=289fdb7c220a24b86edb5b43b29db3d436f75123873b738fb3c7e04b2e3b34ff

        // If hash exists, extract key using URLSearchParams
        if (hash) {
            const keyParam = new URLSearchParams(hash.slice(1)).get('k'); // Remove '#' and parse as query parameters
            if (keyParam) {
                // Replace spaces with '+' and decode the key properly
                const decodedKey = decodeURIComponent(keyParam.replace(/\s/g, '+'));
                setDecryptKey(decodedKey); // Store the key in state
            }
        }
    }, []); // Empty dependency array, runs only once on mount

    return (
        <Container sx={{ mt: 2 }}>
             <Typography variant="h4" gutterBottom>
                Share a Secret
            </Typography>
            <Typography variant="body1" paragraph>
                Share a secret with your friends and collegues securely and privately.
                Your secrets are encrypted and can only be accessed by those you share the link with.
            </Typography>
            <Grid container spacing={2} direction="column">
                <Grid item xs={12}>
                    <ViewSecret secretId={secretId} decryptKey={decryptKey} />
                </Grid>
                <Grid item xs={12}>
                    <Faq />
                </Grid>
            </Grid>
        </Container>
    );
};

export default View;
